<script>
import FormElement from '@wielink-application/shared/vue/components/form/input-only/datetime.vue'

export default FormElement;
</script>